import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { CreateMembershipGroupFormSchemaValues as FormSchemaValues } from 'src/features/memberships/api/useCreateMembershipGroup';
import type { MembershipGroup } from 'src/features/memberships/types';

const RESOURCE = '/parkings/:parkingId/membership-groups/:membershipGroupId/';

interface DTO extends Omit<FormSchemaValues, 'valid_range'> {
    parkingId: string;
    membershipGroupId: number;
    valid_from: string;
    valid_until: string;
}

type MutationFnType = typeof mutationFn;
const mutationFn = ({ parkingId, membershipGroupId, ...data }: DTO): Promise<MembershipGroup> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, membershipGroupId }), data);
};

interface UseMutationOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}
const useMutationHook = (options: UseMutationOptions = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { RESOURCE as UPDATE_MEMBERSHIP_GROUP_RESOURCE, useMutationHook as useUpdateMembershipGroup };
export type { DTO as UpdateMembershipGroupDTO, FormSchemaValues as UpdateMembershipGroupFormSchemaValues };
